import React from "react";
import { Component } from "react";
import CollegeContainer from "../Container/CollegeContainer";
import Campus2 from "./CampusForm";
import { notify } from "react-notify-toast";
import { API } from "../../API";

import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import { connect } from "react-redux";
import { createCampus, addCampusToPersonnel } from "../../redux/college/college.actions"
import { permIndices } from "../../Permissions"
import "../../Components/Tabs/TabButton.css"

// Disable outline for focused item
import "./app.css"

export class Campus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabPairs: [],
      campuses: this.props.campuses || [],
      // customer: null,
      width: 0,
      index: 0,
      initialChange: false,
      addingNewCampus: false
    };
    this.ccomp = React.createRef();

    if (this.props.user === null) {
      window.location = "/login";
    }
  }

  clickTab = (key) => {
    if(key === "addNew") {
      this.setState({
        addingNewCampus: true
      })
    }
    else {
      this.setState({
        addingNewCampus: false
      })
    }
    this.ccomp.current.swapTab(key);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  setTabPairs = () => {
    const { campuses } = this.props;
    var tabPairs = []
    for (let campus of campuses) {
      const tabPair = {
        tabKey: campus._id,
        rn: campus.reference_name || 'default_ref',
      }
      tabPairs.push(tabPair)
    }
    this.setState({
      tabPairs: tabPairs,
    })
  }

  componentDidMount = () => {
    this.setState({
      index: 1,
    }, () => {
      this.setState({
        index: 0,
      })
    })
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.setTabPairs();
  }

  componentDidUpdate(prevProps) {
    // console.log("testing props update")
    if (JSON.stringify(prevProps.campuses) !== JSON.stringify(this.props.campuses)) {
      // console.log(prevProps.campuses, this.props.campuses)
      this.setTabPairs();
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  tabs = this.props.user.role === 'customer' ? [
    {
      text: this.props.user?.is_childcare_centre ? "Centre" : "Campus",
      pathname: "/Campus",
      active: true,
    },
    {
      text: "Personnel",
      pathname: "/Personnel",
    },
    {
      text: this.props.user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
    },
    {
      text: "Finance Settings",
      pathname: "/FinanceSetting",
    },
    {
      text: "Budget Settings",
      pathname: "/BudgetSetting",
    },
  ] : [{
    text: this.props.user?.is_childcare_centre ? "Centre" : "Campus",
    pathname: "/Campus",
    active: true,
  },
    {
      text: this.props.user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
    },
  ];

  styles = {
    tabs: {
      background: '#fff',
    },
    slide: {
      padding: 15,
      minHeight: 100,
    },
    slide1: {
      backgroundColor: '#FFFFFF',
    },
  };

  handleChangeIndex = (index) => {
    this.setState({
      index: index,
    })
  }

  handleChange = (event, value) => {
    this.setState({
      index: value,
    });
  };

  addNewCampus = () => {

    var fullcontrol = !this.props.user.permissions
    if (this.props.editcampus) {


      if (fullcontrol) {
        API.createCampus({
          customer_id: this.props.user.customer_id,
          institution_id: this.props.user.institution_id,
        })
          .then((res) => {
            this.props.createCampus(res.data)
            var temp = [...this.state.newCampuses]
            temp.push(res.data)
            this.setState({
              campuses: temp,
              // current_campus: res.data,
            }, () => {
              console.log('new created', res.data)
              // this.setFieldsValue(res.data)
              // const msg = "Campus created successfully";
              // notify.show(msg);
              // window.location.reload();
            })
          })
      } else {
        API.createCampusByPersonnel({
          personnel_id: this.props.user.personnel_id,
          institution_id: this.props.institution._id,
        })
          .then((res) => {
            this.props.addCampusToPersonnel(res.data)
            var temp = this.state.newCampuses
            temp.push(res.data)
            this.setState({
              newCampuses: temp,
              current_campus: res.data,
            }, () => {
              console.log('new created', res.data)
              this.setFieldsValue(res.data)
              // const msg = "Campus created successfully";
              // notify.show(msg);
              window.location.reload();
            })
          })
      }
    } else {
      notify.show("Please contact your manager to acquire access to manage campus")
    }
  }

  render() {
    return (
      <div>
        {(this.state.width > 480) ? (
          <CollegeContainer
            header={ this.props.user?.is_childcare_centre ? "Add Centre" :"Add Campus" }
            user={this.props.user}
            tabs={this.tabs}
            tabPairs={this.state.tabPairs}
            onAdd={this.onAdd}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('campus-Index') != null) ? parseInt(localStorage.getItem('campus-Index')) : 0}
            viewbookings={this.props.viewbookings}
            addable={this.props.editcampus}
          // buttons={buttons}
          >
            <div hidden={this.props.campuses.length == 0 && !this.state.addingNewCampus}>
              <Campus2
                ref={this.ccomp}
                state={this.state}
                deleteTab={this.deleteTab}
                handleFormFieldChange={this.handleFormFieldChange}
                handleSubmit={this.handleSubmit}
                user={this.props.user}
                campuses={this.props.campuses}
                editcampus={this.props.editcampus}
                institution={this.props.institution}
              // setTabPairs={this.setTabPairs}
              />
            </div>
            <div hidden={this.props.campuses.length != 0 || this.state.addingNewCampus} className="absolute-align-items-center">
              <p>Currently there is no data available. Click ADD NEW to create an entry.</p>
            </div>
          </CollegeContainer>
        ) : (
          <CollegeContainer
            header={ this.props.user?.is_childcare_centre ? "Add Centre" :"Add Campus" }
            tabs={this.tabs}
            tabPairs={this.state.tabPairs}
            onAdd={this.onAdd}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('campus-Index') != null) ? parseInt(localStorage.getItem('campus-Index')) : 0}
            viewbookings={this.props.viewbookings}
          // buttons={buttons}
          >
            <Tabs value={this.state.index}
              fullWidth
              onChange={this.handleChange}
              variant="scrollable"
              TabIndicatorProps={{
                style: { background: "#34F1C8", color: "#34F1C8" }
              }}
              scrollButtons="on">
              {this.props.campuses.map((campus) => (
                <Tab label={<span style={this.props.campuses[this.state.index] == campus ? ({ color: "#34F1C8" }) : ({ color: "gray" })}>{campus.reference_name}</span>} />
              ))}
              {this.props.editcampus && <Tab label={<span style={{ color: "#3BB4D8" }}>AddNew</span>} icon={<AddCircleIcon style={{ color: "#3BB4D8" }} />} onClick={this.addNewCampus} />}
            </Tabs>
            <SwipeableViews index={this.state.index} onChangeIndex={this.handleChangeIndex} enableMouseEvents>
              {this.props.campuses.map((campus) => (
                <div style={Object.assign({}, this.styles.slide, this.styles.slide1)}>{/*campus.campus_shortname*/}
                  <Campus2
                    mobileCam={campus}
                    ref={this.ccomp}
                    state={this.state}
                    deleteTab={this.deleteTab}
                    handleFormFieldChange={this.handleFormFieldChange}
                    handleSubmit={this.handleSubmit}
                    user={this.props.user}
                    campuses={this.props.campuses}
                    editcampus={this.props.editcampus}
                    institution={this.props.institution}
                  />
                </div>
              ))}
            </SwipeableViews>

          </CollegeContainer>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    campuses: state.college.campuses,
    institution: state.college.institution,
    viewbookings: 1,
    editcampus: 1,
  }
}

const mapDispatchToProps = (dispatch) => ({
  // For Mobile use
  createCampus: (campusData) => dispatch(createCampus(campusData)),
  addCampusToPersonnel: (campusData) => dispatch(addCampusToPersonnel(campusData)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Campus);
